import { birdieFooterLogo } from '@/assets';

interface EventData {
  title: string;
  occasion: string;
  event_date: string;
  comments: string;
  contact_name: string;
}

interface GiftListHeaderProps {
  event: EventData;
}

export function GiftListHeader({ event }: GiftListHeaderProps) {
  const eventDate = new Date(event.event_date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="bg-[#505F50] text-white">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between max-w-[1240px] py-8 md:py-[53px] px-4 mx-auto">
        <div className="mb-6 md:mb-0">
          <img src={birdieFooterLogo} alt="Birdie Logo" className="h-8 md:h-auto" />
        </div>

        {/* Welcome Message in Header */}
        <div className="md:mt-6">
          <h1 className="text-2xl md:text-[40px] mb-2">Welcome <span className="font-semibold">{event.contact_name}</span></h1>
          <p className="text-lg md:text-2xl font-semibold mb-1">
            Here's your gift list for the {event.title} {eventDate}.
          </p>
          <p className="text-base md:text-xl md:max-w-[808px]">
            Here's your curated gift list—handpicked with your special someone in mind. Browse the list and select how you'd like to move forward with your chosen gifts: place the order yourself, or let the Birdies handle it for you.
          </p>
        </div>
      </div>
    </div>
  );
}